define('Responsive/controllers/OverlayViewController',['require','exports','module','./ViewController','message-service/message-service','jquery'],function(require,exports,module){
    var ViewController = require( './ViewController' ),
        messageService = require( 'message-service/message-service' ),
        $ = require('jquery');

    var Superclass,
        doc = document,
        SPEED = 400;

    function OverlayViewController(opts, view) {
        Superclass.constructor.call(this);

        this.container;
        this.refresh;
        this.closeable;
        this.countdown;
        this.fullscreen = false;
    }

    ViewController.spawn(OverlayViewController).define({
        loadView: function () {
            Superclass.loadView.call(this);
            this.ad = this.ad || document.createElement('div');

            this.view.id = "gd_overlay";
            this.setClassName(this.ad, 'curveball_ad');
            this.closeInterval = -1;

            if (this.closeable) {
                this.closer = this.closer || document.createElement('span');
                this.setClassName(this.closer, 'curveball_adCloser');
                this.view.appendChild(this.closer);

                if (this.countdown > 0) { this.setCountdown(); }
            }

            this.container.presentFloatingModalViewController(this, this.fullscreen);
        },

        setCountdown: function () {
            var that = this;
            that.closer.setAttribute('data-countdownmessage', 'Close this ad in ');
            that.closer.setAttribute('data-countdowntime', this.countdown);

            this.closeInterval = setInterval(function() {
                if (that.countdown === 0) {
                    that.countdown--;
                    that.closer.setAttribute('data-countdowntime', that.countdown);
                    that.killCountdown();
                    that.enableCloseButton();
                }
            }, 1000);
        },

        killCountdown: function() {
            this.closeInterval = -1;
        },

        enableCloseButton: function () {
            var that = this;
            that.closer.addEventListener('click', function () {
                that.exit();
            })
        },

        close: function () {
            var that = this;

            $(this.view).animate({opacity: 0}, SPEED / 2, 'linear', function () {
                that.container.dismissFloatingModalViewController(that, this.fullscreen);
            });
        },

        init: function (opts, view) {
            this.container = opts.view ? opts.view : view;
            this.refresh   = opts.refresh && opts.refresh.toString()==="true";
            this.closeable = opts.closeable!==false;
            this.countdown = opts.countdown ? parseInt(opts.countdown,10) : 0;
        },

        exit: function () {
            this.killCountdown();
            this.close();
        }
    });

    Superclass = OverlayViewController.superclass;
    return OverlayViewController;
});
